export const canauxConstants = {
  GET_CANAUX: "GET_CANAUX",
  GET_CANAL: "GET_CANAL",
};
